import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcLocationEnvironmentInputComponent } from './fc-location-environment-input.component';


@NgModule({
  declarations: [
    FcLocationEnvironmentInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcLocationEnvironmentInputComponent
  ]
})
export class FcLocationEnvironmentInputModule {}
